export enum ViewTypesConstants {
  CECOS = 'CECOS',
  SVA = 'SVA',
  SVB = 'SVB',
  farmacs = 'farmacs',
  escales = 'escales',
  INT = 'INT',
  HNT = 'HNT',
  procediments = 'procediments',
  codisActivacio = 'codisActivacio',
  glossaris = 'glossaris',
  FISTRA = 'FISTRA',
  ETICA = 'ETICA',
  LEGAL = 'LEGAL',
  abreviacions = 'abreviacions',
  repositori = 'repositori'
}

/**
 * INT, HNT, FISTRA, ETICA y LEGAL
 */
export enum ViewTypesDirectContentConstants {
  INT = 'INT',
  HNT = 'HNT',
  FISTRA = 'FISTRA',
  ETICA = 'ETICA',
  LEGAL = 'LEGAL'
}
/**
 * Devuelve true o false si la vista es INT, HNT, FISTRA, ETICA o LEGAL
 *
 * @param view
 * @returns
 */
export const isDirectContentView = (view: ViewTypesConstants) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Object.values(ViewTypesDirectContentConstants).includes(view as any);

/**
 * FÀRMACS | ESCALES | glossaris
 */
export enum ViewTypesAlphabeticalGroupConstants {
  FARMACS = 'farmacs',
  ESCALES = 'escales',
  glossaris = 'glossaris',
  abreviacions = 'abreviacions'
}
/**
 * Devuelve true o false si la vista es FÀRMACS | ESCALES | glossaris
 *
 * @param view
 * @returns
 */
export const isAlphabeticalGroupView = (view: ViewTypesConstants) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Object.values(ViewTypesAlphabeticalGroupConstants).includes(view as any);

/**
 * Checks if the given route is alphabetical.
 *
 * @param route - The route to check.
 * @returns True if the route contains '/farmacs', '/escales', or '/glossaris', otherwise false.
 */
export const isAlphabeticalRoute = (route: string) =>
  route.includes('/farmacs') || route.includes('/escales') || route.includes('/glossaris');

/**
 * (buida) procediments ara es mostra agrupat per blocs tematics, veure isThematicBlockView
 */
export enum ViewTypesAlphanumericalListConstants {}
/**
 * Devuelve true o false si la vista es de tipo ViewTypesAlphanumericalListConstants
 *
 * @param view
 * @returns
 */
export const isAlphanumericalListView = (view: ViewTypesConstants) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Object.values(ViewTypesAlphanumericalListConstants).includes(view as any);

/**
 * codisActivacio
 */
export enum ViewPdfListConstants {
  codisActivacio = 'codisActivacio'
}
/**
 * Devuelve true o false si la vista es codisActivacio
 *
 * @param view
 * @returns
 */
export const isPdfListView = (view: ViewTypesConstants) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Object.values(ViewPdfListConstants).includes(view as any);

/**
 * CECOS, SVA o SVB
 */
export enum ViewTypesGuiesCliniquesConstants {
  CECOS = 'CECOS',
  SVA = 'SVA',
  SVB = 'SVB'
}

/**
 * Devuelve true o false si la vista es CECOS, SVA o SVB
 *
 * @param view
 * @returns
 */
export const isClinicGuideView = (view: ViewTypesConstants) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Object.values(ViewTypesGuiesCliniquesConstants).includes(view as any);

/**
 * repositori
 */
export enum ViewRepositoryListConstants {
  repositori = 'repositori'
}
/**
 * Devuelve true o false si la vista es repositori
 *
 * @param view
 * @returns
 */
export const isRepositoryListView = (view: ViewTypesConstants) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Object.values(ViewRepositoryListConstants).includes(view as any);

/**
 * CECOS, SVA, SVB o procediments (vistes agrupades per blocs tematics, amb camp blocTematic)
 */
export const isThematicBlockView = (view: ViewTypesConstants) =>
  isClinicGuideView(view) || view === ViewTypesConstants.procediments;

/**
 * CECOS, SVA, SVB, farmacs, escales, procediments, codisActivacio or glossaris
 */
export enum ViewTypesWithRelationhips {
  CECOS = 'CECOS',
  SVA = 'SVA',
  SVB = 'SVB',
  farmacs = 'farmacs',
  escales = 'escales',
  procediments = 'procediments',
  codisActivacio = 'codisActivacio',
  glossaris = 'glossaris',
  abreviacions = 'abreviacions'
}

/**
 * Devuelve true o false si la vista es de tipo ViewTypesWithRelationhips
 *
 * @param view
 * @returns
 */
export const isARelationatedView = (view: ViewTypesConstants) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Object.values(ViewTypesWithRelationhips).includes(view as any);
